import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const styles = {
  accordion: {
    "&.Mui-expanded": {
      margin: "4px 0",
    },
  },
  accordionSummary: {
    flexDirection: "row-reverse",
    minHeight: "48px !important",
    "& .MuiAccordionSummary-content": {
      margin: "12px 0 !important",
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "12px 0 !important",
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      marginRight: 1,
      marginLeft: 0,
    },
  },
};

const FieldSectionAccordion = ({
  sectionKey,
  title,
  fields,
  checkedCount,
  expanded,
  onChange,
  component: Checkbox,
}) => {
  // Sort fields alphabetically by label
  const sortedFields = React.useMemo(() => {
    return [...fields].sort((a, b) => {
      const labelA = a[2] || '';
      const labelB = b[2] || '';
      return labelA.localeCompare(labelB);
    });
  }, [fields]);
  return (
    <Accordion key={sectionKey} expanded={expanded} onChange={onChange} sx={styles.accordion}>
      <AccordionSummary
        expandIcon={expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowRightIcon />}
        sx={styles.accordionSummary}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h6" color="textSecondary">
            {title}
          </Typography>
          <Chip label={checkedCount} size="small" />
        </Box>
      </AccordionSummary>
      {expanded && (
        <AccordionDetails>
          {sortedFields.map(([name, category, label]) => (
            <Box key={name}>
              <Checkbox name={name} category={category} label={label} />
            </Box>
          ))}
        </AccordionDetails>
      )}
    </Accordion>
  );
};

export default FieldSectionAccordion;
